export default () => ({
  tutorialSteps: [
    [1, 3],
    [3, 3],
    [-1, 2],
    [2, 1],
    [2, 2]
  ],
  title: '#03',
  mapStr: `
    --b--
    -b-b-
    -c-p-
    ggwrr
    -g-r-
  `
})



// WEBPACK FOOTER //
// ./src/levels/tutorial-3.js